var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "download",
    style: _vm.boxStyle,
    on: {
      "touchmove": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "download-container",
    style: _vm.containerStyle
  }, [_c('div', {
    staticClass: "download-top",
    style: _vm.topStyle
  }, [_vm._t("top", function () {
    return [_c('img', {
      staticClass: "download-top-img",
      attrs: {
        "src": _vm.bdImg
      }
    })];
  })], 2), _c('div', {
    staticClass: "download-content",
    style: _vm.contentStyle
  }, [_vm._t("content", function () {
    return [_c('div', {
      staticClass: "download-content-title"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
      staticClass: "sub-title"
    }, [_vm._v(_vm._s(_vm.subTitle))])])];
  })], 2), _c('div', {
    staticClass: "download-footer",
    style: _vm.footerStyle
  }, [_vm._t("footer", function () {
    return [_c('div', {
      staticClass: "download-footer-box"
    }, _vm._l(_vm.btnArr, function (item, index) {
      return _c('div', {
        key: 'btn' + index,
        class: [item.type, 'footer-button'],
        on: {
          "click": function ($event) {
            return _vm.handleClick(item);
          }
        }
      }, [_vm._v(" " + _vm._s(item.text) + " ")]);
    }), 0)];
  })], 2)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.downloadFlag,
      expression: "downloadFlag"
    }],
    staticClass: "mask",
    on: {
      "click": function ($event) {
        return _vm.handleClick({
          method: 'close'
        });
      }
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };